import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { SharedDirectivesModule } from '../../shared-directives.module';

import { NzButtonModule } from 'ng-zorro-antd/button';
import { NoticeViewComponent } from './components/notice-view.component';
import { NoticeViewContentDirective } from './directives/notice-view-content.directive';
import { NoticeViewTitleDirective } from './directives/notice-view-title.directive';

@NgModule({
  imports: [CommonModule, TranslateModule, SharedDirectivesModule, NzButtonModule],
  declarations: [NoticeViewComponent, NoticeViewTitleDirective, NoticeViewContentDirective],
  exports: [NoticeViewComponent, NoticeViewTitleDirective, NoticeViewContentDirective],
})
export class NoticeViewModule {}
